export default __webpack_public_path__ + "static/media/icon_schedule_triangle.9683995d.svg";